import { createRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { authenticatedRoute } from '@/authenticated-route';
import * as patient360 from '@/shared/patient-360';
import { IMAGE_MANAGEMENT_ROUTES } from './consts/routes';
import { getSuspenseQueryAllImageTagsOptions } from './services/use-query-all-image-tags';
import { gallerySearchParams } from './types/gallery-search-params';
import { imageEditorSearchSchema } from './types/image-editor-search-schema';

const getParentRoute = () => authenticatedRoute;

const galleryMaintenanceRoute = createRoute({
  getParentRoute,
  path: IMAGE_MANAGEMENT_ROUTES.galleryMaintenance,
  validateSearch: zodValidator(gallerySearchParams),
  loader: async ({ context }) => {
    const { queryClient } = context;

    const data = await queryClient.ensureQueryData(
      getSuspenseQueryAllImageTagsOptions(),
    );

    return data;
  },
}).lazy(() => import('./gallery-maintenance').then(({ Route }) => Route));

const annotatorRoute = createRoute({
  getParentRoute,
  path: IMAGE_MANAGEMENT_ROUTES.annotator,
}).lazy(() => import('./image-annotator').then(({ Route }) => Route));

const imageEditorRoute = createRoute({
  getParentRoute,
  path: IMAGE_MANAGEMENT_ROUTES.imageEditor,
  validateSearch: zodValidator(imageEditorSearchSchema),
  staticData: {
    patientCardSource: patient360.CdrPatientCardSource,
  },
}).lazy(() => import('./image-editor').then(({ Route }) => Route));

export const imageManagementRoute = createRoute({
  getParentRoute,
  path: IMAGE_MANAGEMENT_ROUTES.index,
  beforeLoad: () => {
    throw redirect({ to: IMAGE_MANAGEMENT_ROUTES.galleryMaintenance });
  },
}).addChildren([galleryMaintenanceRoute, annotatorRoute, imageEditorRoute]);
